import { render, staticRenderFns } from "./OverdueRegisterDialog.vue?vue&type=template&id=04387b9a&"
import script from "./OverdueRegisterDialog.vue?vue&type=script&lang=js&"
export * from "./OverdueRegisterDialog.vue?vue&type=script&lang=js&"
import style0 from "./OverdueRegisterDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports